/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WebAuthnListCredentialsResponse } from '../models/WebAuthnListCredentialsResponse';
import type { WebAuthnRegistrationBeginRequest } from '../models/WebAuthnRegistrationBeginRequest';
import type { WebAuthnRegistrationBeginResponse } from '../models/WebAuthnRegistrationBeginResponse';
import type { WebAuthnRegistrationCompleteRequest } from '../models/WebAuthnRegistrationCompleteRequest';
import type { WebAuthnRegistrationCompleteResponse } from '../models/WebAuthnRegistrationCompleteResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WebauthnService {
    /**
     * Begin WebAuthn credential registration
     * Start the WebAuthn registration process to add a new authenticator (requires escalation)
     * @param requestBody
     * @param userSession
     * @returns WebAuthnRegistrationBeginResponse Successful Response
     * @throws ApiError
     */
    public static beginWebauthnRegistration(
        requestBody: WebAuthnRegistrationBeginRequest,
        userSession?: (string | null),
    ): CancelablePromise<WebAuthnRegistrationBeginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/credentials/webauthn/register/begin',
            cookies: {
                'user_session': userSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Complete WebAuthn credential registration
     * Complete the WebAuthn registration by verifying the credential (requires escalation)
     * @param requestBody
     * @param userSession
     * @returns WebAuthnRegistrationCompleteResponse Successful Response
     * @throws ApiError
     */
    public static completeWebauthnRegistration(
        requestBody: WebAuthnRegistrationCompleteRequest,
        userSession?: (string | null),
    ): CancelablePromise<WebAuthnRegistrationCompleteResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/credentials/webauthn/register/complete',
            cookies: {
                'user_session': userSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List WebAuthn credentials
     * Get all WebAuthn credentials registered by the current user
     * @param userSession
     * @returns WebAuthnListCredentialsResponse Successful Response
     * @throws ApiError
     */
    public static listWebauthnCredentials(
        userSession?: (string | null),
    ): CancelablePromise<WebAuthnListCredentialsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/credentials/webauthn',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete WebAuthn credential
     * Remove a WebAuthn credential from the user's account (requires escalation)
     * @param credentialId
     * @param userSession
     * @returns void
     * @throws ApiError
     */
    public static deleteWebauthnCredential(
        credentialId: string,
        userSession?: (string | null),
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/credentials/webauthn/{credential_id}',
            path: {
                'credential_id': credentialId,
            },
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke Core Passkey binding
     * Clear the Core Passkey binding edge on a credential. The credential stays as a standard synced passkey (requires escalation).
     * @param credentialId
     * @param userSession
     * @returns void
     * @throws ApiError
     */
    public static revokeWebauthnBinding(
        credentialId: string,
        userSession?: (string | null),
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/credentials/webauthn/{credential_id}/binding',
            path: {
                'credential_id': credentialId,
            },
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
